if (!customElements.get('ssb-spa-formula-title')) {
  customElements.define('ssb-spa-formula-title', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const titleId = `SpaFormulaTitle-${this.dataset.section}`;
        const nextTitle = data.html?.getElementById(titleId);
        const currentTitle = this.querySelector('h1');
        if (nextTitle && currentTitle) currentTitle.textContent = nextTitle.textContent;
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
    }
  });
}
if (!customElements.get('ssb-spa-formula-grid')) {
  customElements.define('ssb-spa-formula-grid', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('ul');
      this.choices = Array.from(this.querySelectorAll('[data-spa-choice]'));
      this.sortSelect = this.querySelector('[data-spa-sort]');
      this.onSort = () => {
        const sort = this.sortSelect.value;
        const ordered = [...this.choices];
        if (sort === 'title') ordered.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
        if (sort === 'price-ascending') ordered.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (sort === 'price-descending') ordered.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
        this.grid.append(...ordered);
      };
      this.sortSelect.addEventListener('change', this.onSort);
      this.querySelector('[data-spa-sort-control]').hidden = false;
    }
    disconnectedCallback() {
      this.sortSelect?.removeEventListener('change', this.onSort);
    }
  });
}
